import {
  EquipSlotTranslation,
  IItem,
  WeaponProfTranslation,
} from '../../../../../../api/types/item'
import React from 'react'
import { Box, Typography } from '@mui/material'

export const ItemBaseStats: React.FC<{ item: IItem }> = ({ item }) => {
  return (
    <Box mb={1.5}>
      {item.consumable && <Typography color="text.secondary">Konsumowalny</Typography>}
      {item.stackable && <Typography color="text.secondary">Stakowalny</Typography>}
      {item.charges > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Maksymalna ilość ładunków</Typography>
          <Typography color="text.secondary"> {item.charges}</Typography>
        </Box>
      )}

      {item.equip_slot && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Element ekwipunku</Typography>
          <Typography color="text.secondary">
            {EquipSlotTranslation[item.equip_slot].toLowerCase()}
            {item.two_handed && ' (dwuręczny)'}
          </Typography>
        </Box>
      )}
      {item.weapon_prof && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Biegłość broni</Typography>
          <Typography color="text.secondary">
            {WeaponProfTranslation[item.weapon_prof].toLowerCase()}
          </Typography>
        </Box>
      )}
      {item.delay && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Opóźnienie</Typography>
          <Typography color="text.secondary">{item.delay}</Typography>
        </Box>
      )}
      {item.range && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Zasięg</Typography>
          <Typography color="text.secondary">{item.range}</Typography>
        </Box>
      )}
      {item.strength_mod && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="text.secondary">Użycie siły</Typography>
          <Typography color="text.secondary">{item.strength_mod}</Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="text.secondary">Waga</Typography>
        <Typography color="text.secondary">{item.weight} kg</Typography>
      </Box>
    </Box>
  )
}
